import { getMeta, formatCommentText } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import TwygsAvatar from '../../../../assets/twygs-avatar-notification.svg';
import WarningRectangleCircleIcon from '../../../../assets/warning-rectangle-icon.svg';

const ModerationFlaggedNotification = ({ notification }) => {
  const meta = getMeta(notification);
  const contentType = meta.contentType === 'comment' ? 'comment' : 'article';
  const reason = meta.reason || 'potentially inappropriate';
  const displayComment = formatCommentText(meta.commentText);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={TwygsAvatar} subIcon={WarningRectangleCircleIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="font-extrabold text-sm text-growth-green-900">
          Your {contentType} <span className="text-amber-600">has been flagged for review</span>
        </p>

        {meta.articleTitle && (
          <p className="text-sm text-gray-600 mb-2">
            {contentType === 'comment' ? `on "${meta.articleTitle}"` : `"${meta.articleTitle}"`}
          </p>
        )}

        {displayComment && (
          <div className="bg-white rounded-md p-2 mb-2 border border-[#E5E7EB] mt-2">
            <p className="text-xs text-black break-words">"{displayComment}"</p>
          </div>
        )}

        <p className="text-xs text-gray-600">
          <span className="font-bold">Reason:</span> {reason}. It will be reviewed by our moderation
          team.
        </p>
      </div>
    </div>
  );
};

export default ModerationFlaggedNotification;
